import * as PrefabManager from '../PrefabManager';
import {
    game
} from "../../Game";
import { Settings } from '../../Settings';

const SEGMENTS = 7;
const SEGMENT_LENGTH = 1.0;
const SEGMENT_HALF_WIDTH = 0.2;
const SEGMENT_DENSITY = 0.35;
// The rope between the halves is shorter than the guts, so the guts sag
// instead of carrying the lower body.
const ROPE_LENGTH = SEGMENTS * SEGMENT_LENGTH * 0.9;

const vec = new Box2D.b2Vec2(0, 0);

const objects = [];
const halfLength = SEGMENT_LENGTH / 2;
const vertices = [
    {x: -SEGMENT_HALF_WIDTH, y: -halfLength},
    {x: SEGMENT_HALF_WIDTH, y: -halfLength},
    {x: SEGMENT_HALF_WIDTH, y: halfLength},
    {x: -SEGMENT_HALF_WIDTH, y: halfLength},
];
for (let i = 0; i < SEGMENTS; i++) {
    const y = (i + 0.5) * SEGMENT_LENGTH;
    objects.push([0, 0, y, 0, '', `part${i + 1}`, i * 2, ['#999999'], ['#000'], [0], false, true, [vertices], [SEGMENT_DENSITY], 5, [null], '', [1], true, false, false, [0.5], [0]]);
    objects.push([1, 0, y * Settings.PTM, 0, '', '', i * 2 + 1, 'Gore_Intestine0000', i * 2, 0, 0, 0, false, '#FFFFFF']);
}
for (let i = 1; i < SEGMENTS; i++) {
    objects.push([2, 0, i * SEGMENT_LENGTH * Settings.PTM, 0, '', `part${i}_joint`, SEGMENTS * 2 + i - 1, (i - 1) * 2, i * 2, 0, false, false, 1, 10, false, 0, 0, 0, 0, 0, 0]);
}

class Intestines extends PrefabManager.basePrefab {
}

PrefabManager.prefabLibrary.Intestines = {
    json: JSON.stringify({objects}),
    class: Intestines,
}

const pin = (body, segment, point) => {
    const jointDef = new Box2D.b2RevoluteJointDef();
    vec.Set(point.x, point.y);
    jointDef.Initialize(body, segment, vec);
    jointDef.set_collideConnected(false);
    game.editor.CreateJoint(jointDef);
    Box2D.destroy(jointDef);
};

const velocityAt = (body, point) => {
    const velocity = body.GetLinearVelocityFromWorldPoint(point);
    return {x: velocity.x, y: velocity.y};
};

export const spillIntestines = (upper, lower, upperAnchor, lowerAnchor, forwardAngle) => {
    const start = {x: upperAnchor.x, y: upperAnchor.y};
    const end = {x: lowerAnchor.x, y: lowerAnchor.y};
    const upperVelocity = velocityAt(upper, upperAnchor);
    const lowerVelocity = velocityAt(lower, lowerAnchor);

    const guts = game.editor.buildJSON({objects: [[4, start.x * Settings.PTM, start.y * Settings.PTM, 0, {}, 'Intestines']]});

    const radius = SEGMENT_LENGTH / (2 * Math.sin(Math.PI / SEGMENTS));
    const centerX = start.x + Math.cos(forwardAngle) * radius;
    const centerY = start.y + Math.sin(forwardAngle) * radius;
    // The guts start as a loop in front of the waist. Leaving towards the upper
    // half keeps the loop from crossing itself as the halves come apart.
    const upperPosition = upper.GetPosition();
    const sweep = Math.sin(forwardAngle) * (upperPosition.x - start.x) - Math.cos(forwardAngle) * (upperPosition.y - start.y) >= 0 ? 1 : -1;
    const point = i => {
        const angle = forwardAngle + Math.PI + sweep * i * 2 * Math.PI / SEGMENTS;
        const share = i / SEGMENTS;
        return {
            x: centerX + Math.cos(angle) * radius + (end.x - start.x) * share,
            y: centerY + Math.sin(angle) * radius + (end.y - start.y) * share,
        };
    };

    guts._bodies.forEach((segment, i) => {
        const from = point(i);
        const to = point(i + 1);
        vec.Set((from.x + to.x) / 2, (from.y + to.y) / 2);
        segment.SetTransform(vec, Math.atan2(from.x - to.x, to.y - from.y));
        vec.Set((upperVelocity.x + lowerVelocity.x) / 2, (upperVelocity.y + lowerVelocity.y) / 2);
        segment.SetLinearVelocity(vec);
        game.editor.updateBodyPosition(segment);
    });

    pin(upper, guts._bodies[0], point(0));
    pin(lower, guts._bodies[SEGMENTS - 1], point(SEGMENTS));

    const ropeJointDef = new Box2D.b2DistanceJointDef();
    vec.Set(start.x, start.y);
    ropeJointDef.Initialize(upper, lower, vec, vec);
    ropeJointDef.set_minLength(0);
    ropeJointDef.set_maxLength(ROPE_LENGTH);
    ropeJointDef.set_stiffness(0);
    ropeJointDef.set_damping(0);
    const rope = game.editor.CreateJoint(ropeJointDef);
    Box2D.destroy(ropeJointDef);

    return {guts, rope};
};
